import { render } from "./ComprehensiveAnalytics.vue?vue&type=template&id=c590814a&scoped=true"
import script from "./ComprehensiveAnalytics.vue?vue&type=script&lang=js"
export * from "./ComprehensiveAnalytics.vue?vue&type=script&lang=js"

import "./ComprehensiveAnalytics.vue?vue&type=style&index=0&id=c590814a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c590814a"]])

export default __exports__